import { AmortizationScheduleParams } from 'app/models/amortitation-schedule'

export const getFacilitySchedulerAmortization = (state: { amortizationSchedule: { facilitySchedulerAmortization: AmortizationScheduleParams } }) =>
  state.amortizationSchedule.facilitySchedulerAmortization
